
function warningMessageDialog () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/warning-message/warning-message-dialog.html?$$REVISION$$'
  }
}
export { warningMessageDialog }
